import type { ISxProps } from '@/CommonComponents/types'
import { Paper as MUIPaper } from '@mui/material'
interface IPaperProps {
  sx?: ISxProps
  square?: boolean
  elevation?: number
  children: React.ReactNode
}

export default function Paper({ sx, square, elevation, children }: IPaperProps) {
  return (
    <MUIPaper sx={sx} square={square} elevation={elevation}>
      {children}
    </MUIPaper>
  )
}
